export var createApiKeysApi = function (baseUrl, http) {
    return {
        getApiKeys: function () { return http.get(baseUrl + "/apiKeys"); },
        getApiKey: function (id) { return http.get(baseUrl + "/apiKeys/" + id); },
        addApiKey: function (dto) { return http.post(baseUrl + "/apiKeys", dto); },
        updateApiKey: function (dto) { return http.put(baseUrl + "/apiKeys/" + dto.id, dto.data); },
        deleteApiKey: function (id) { return http.delete(baseUrl + "/apiKeys/" + id); }
    };
};
//# sourceMappingURL=index.js.map